import React from "react";
import { Link, useLocation } from "react-router-dom";
import clearResultLogo from "../../../assets/images/logo.png";
import dashboardIcon_dark from "../../../assets/icons/dashboardIcon_dark.png";
import dashboardIcon_light from "../../../assets/icons/dashboardIcon_light.png";
import taskIcon_dark from "../../../assets/icons/taskIcon_dark.png";
import taskIcon_light from "../../../assets/icons/taskIcon_light.png";
import appDetail_icon_dark from "../../../assets/icons/appDetail_icon_dark.png";
import appDetail_icon_light from "../../../assets/icons/appDetail_icon_light.png";
import paymentDetail_icon_dark from "../../../assets/icons/paymentDetail_icon_dark.png";
import paymentDetail_icon_light from "../../../assets/icons/paymentDetail_icon_light.png";
import serverProcessingIcon_dark from "../../../assets/icons/serverProcessingIcon_dark.png";
import serverProcessingIcon_light from "../../../assets/icons/serverProcessingIcon_light.png";

const SuperAdminSidebar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="flex flex-col h-full items-center bg-[#F8F8F8] ">
      <img
        src={clearResultLogo}
        alt="Clear result"
        className="w-[50%] mt-3 mb-3"
      />
      <div className="flex flex-col justify-between w-[80%]">
        <Link to="/super-admin">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/super-admin") ? "active" : ""
            }`}
          >
            {isActive("/super-admin") ? (
              <img
                src={dashboardIcon_light}
                className="mr-3 text-white w-[30px]"
                alt="dashboard"
              />
            ) : (
              <img
                src={dashboardIcon_dark}
                className="mr-3 text-white w-[30px]"
                alt="dashboard"
              />
            )}
            Dashboard
          </div>
        </Link>
        <Link to="/super-admin/support-ticket">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/super-admin/support-ticket") ? "active" : ""
            }`}
          >
            {isActive("/super-admin/support-ticket") ? (
              <img
                src={taskIcon_light}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            ) : (
              <img
                src={taskIcon_dark}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            )}
            Support Ticket
          </div>
        </Link>
        <Link to="/super-admin/app-details">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/super-admin/app-details") ? "active" : ""
            }`}
          >
            {isActive("/super-admin/app-details") ? (
              <img
                src={appDetail_icon_light}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            ) : (
              <img
                src={appDetail_icon_dark}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            )}
            App Details
          </div>
        </Link>
        <Link to="/super-admin/payment-details">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/super-admin/payment-details") ||
              isActive("/super-admin/subscription-history")
                ? "active"
                : ""
            }`}
          >
            {isActive("/super-admin/payment-details") ||
            isActive("/super-admin/subscription-history") ? (
              <img
                src={paymentDetail_icon_light}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            ) : (
              <img
                src={paymentDetail_icon_dark}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            )}
            Payment Details
          </div>
        </Link>
        <Link to="/super-admin/serve-processing-details">
          <div
            className={`flex items-center p-2 px-6 rounded-lg cursor-pointer mt-4 ${
              isActive("/super-admin/serve-processing-details") ? "active" : ""
            }`}
          >
            {isActive("/super-admin/serve-processing-details") ? (
              <img
                src={serverProcessingIcon_light}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            ) : (
              <img
                src={serverProcessingIcon_dark}
                alt="tasks"
                className="mr-3 text-white w-[30px]"
              />
            )}
            Serve Processing Details
          </div>
        </Link>
      </div>
    </div>
  );
};

export default SuperAdminSidebar;
